<template lang="pug">
  button.c-btn.c-btn--round.v-follow-button(
    type="button",
    :class="buttonClass",
    @click="toggleStatus",
    @mouseover="onMouseEvent(true)",
    @mouseleave="onMouseEvent(false)",
    @touchend="onTouchEvent"
  )
    i.icon-ok(v-if="isFollowing")
    i.icon-plus(v-else)
    template(v-if="!isFollowing && $slots.followLabel"): slot(name="followLabel")
    template(v-if="isFollowing && $slots.unfollowLabel"): slot(name="unfollowLabel")

    .v-tooltip(:class="tooltipClass")
      p.u-weight-bold.u-mt0.u-mb0 Follow This Label
      | You’ll receive email updates on new products with this label.
</template>

<script>
export default {
  props: {
    labelId: String,
    fetchSelf: Boolean,

    tooltip: {
      type: Boolean,
      default: true
    },
    // top or bottom
    tooltipPosition: {
      type: String,
      default: 'top'
    }
  },

  data() {
    return {
      mouseEntered: false,
      touched: false,
      afterFollowTooltipTimeoutId: NaN
    };
  },

  computed: {
    label() {
      return this.findById(this.labelId);
    },

    isFollowing() {
      return this.label && this.label.is_following;
    },

    buttonClass() {
      return {
        'c-btn--follow-label': true,
        'c-btn--inverse': this.isFollowing
      };
    },

    tooltipClass() {
      return {
        in: this.isShowToolTip,
        'v-tooltip--bottom': this.tooltipPosition === 'bottom'
      };
    },

    isShowToolTip() {
      if (!this.tooltip || (this.isFollowing && !this.touched)) {
        return false;
      }
      return this.touched || this.mouseEntered;
    }
  },

  mounted() {
    if (this.fetchSelf && this.$store.state.user.is_login && !this.label) {
      return this.$store
        .dispatch('labels/fetch', { label_id: this.labelId })
      .then(() => {
        return this.$emit('change', this.isFollowing);
      });
    }
  },

  methods: {
    findById(id) {
      return this.$store.getters['labels/findById'](id);
    },

    onMouseEvent(b) {
      if (this.$store.state.user.is_smart_phone_device) {
        return;
      }
      this.mouseEntered = b;
    },

    onTouchEvent() {
      if (!this.$store.state.user.is_smart_phone_device) {
        return;
      }
      if (!this.isFollowing) {
        this.touched = true;
        clearTimeout(this.afterFollowTooltipTimeoutId);
        this.afterFollowTooltipTimeoutId = setTimeout(() => {
          this.touched = false;
        }, 3000);
      }
    },

    toggleStatus() {
      if (this.$store.state.user.is_login) {
        this.$store
          .dispatch('labels/toggle', this.labelId)
          .then(() => {
            this.$emit('change', this.isFollowing);
          })
          .then(() => {
          // 既にフォローしていた場合はストアにデータが存在するのでfetchしない
          if (!this.isFollowing) {
            return Promise.resolve();
          }
          return this.$store.dispatch('labels/fetch', this.labelId);
        });
      } else {
        window.location.href = `/signup?r=${encodeURIComponent(
          window.location.href
        )}&via=follow_label&follow_label_id=${this.labelId}`;
      }
    }
  }
};
</script>

<style scoped>
.v-follow-button {
  position: relative;
}

.v-tooltip {
  position: absolute;
  display: inline-block;
  pointer-events: none;
  opacity: 0;
  transform: scale(0.8);
  transform-origin: 90% bottom;
  transition: opacity 0.15s linear, transform 0.15s linear;
  background-color: #2b2b2b;
  border-radius: 2px;
  padding: 5px 10px;
  width: 210px;
  bottom: 105%;
  right: -5px;
  font-size: 1.2rem;
  text-align: left;
  color: #ffffff;
  white-space: normal;
  z-index: 10;
  /* Z-INDEX_TOOLTIP */
}

.v-tooltip:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  bottom: -4px;
  right: 20px;
  border-top: 4px solid #2b2b2b;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

.v-tooltip--bottom {
  top: 105%;
  bottom: auto;
  right: auto;
  left: 50%;
  transform-origin: 50% top;
  margin-left: -100px;
}

.v-tooltip--bottom:before {
  border-top: none;
  border-bottom: 4px solid #2b2b2b;
  top: -4px;
  bottom: auto;
  right: 105px;
}

.v-tooltip.in {
  opacity: 0.95;
  transform: scale(1);
}
</style>
